module.exports = __webpack_public_path__ + "static/img/1-4.04b8141d.png";